import {
  Component,
  Input,
  ContentChildren,
  QueryList,
  ChangeDetectionStrategy
} from '@angular/core';
import { ZefReactiveComponent } from '@zerops/zef/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap, filter } from 'rxjs/operators';
import { ObservableInput } from 'observable-input';
import { selectZefStateSwitcherState } from './state-switcher.selector';
import { StateSwitcherStateComponent } from './modules/state-switcher-state.component';

@Component({
  selector: 'zef-state-switcher',
  templateUrl: './state-switcher.container.html',
  styleUrls: [ './state-switcher.container.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StateSwitcherContainer extends ZefReactiveComponent {

  // # Event Streams

  // # Forms

  // # Data
  // -- angular
  @ObservableInput()
  @Input('key')
  key$!: Observable<string>;

  @ContentChildren(StateSwitcherStateComponent)
  statesRef: QueryList<StateSwitcherStateComponent>;

  // -- sync

  // -- async
  switcherState$ = this.key$.pipe(
    filter((key) => !!key),
    switchMap((key) => this._store.pipe(select(selectZefStateSwitcherState(key))))
  );

  // # State resolver
  state = this.$connect({ switcherState: this.switcherState$ });

  // # Action Streams

  constructor(
    private _store: Store<any>
  ) {
    super();
  }

}
